



























import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import resurvey from '@/views/AiiTasks/resurvey.vue'
import AddResurveyMixin from './addResurveyMixin'

@Component({
	components: {
		resurvey,
	},
})
export default class AddResurvey extends Mixins(AddResurveyMixin) {}
